import { render, staticRenderFns } from "./MeshCreateFolderFrameDialog.vue?vue&type=template&id=0747b71d"
import script from "./MeshCreateFolderFrameDialog.vue?vue&type=script&lang=js"
export * from "./MeshCreateFolderFrameDialog.vue?vue&type=script&lang=js"
import style0 from "./MeshCreateFolderFrameDialog.vue?vue&type=style&index=0&id=0747b71d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports